<template>
  <section class="out --fullscreen">
    <div class="container">
      <img
        v-if="!['1058', '1060'].includes(advertiserAccountId)"
        :src="advertiserLogo"
        style="width: 200px"
      />
      <div class="loader" style="margin: 32px auto;"></div>
      <p
        style="font-size: 18px; margin: 0; padding: 0 24px; text-align: center; font-weight: 600"
      >
        Sending you to <b>{{ advertiserName }}</b> to view the vehicle's
        details...
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Out",
  props: {
    advertiserAccountId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      advertiserLogo: "",
      advertiserName: "",
      advertiserNameMap: {
        "1052": "CarGurus.com",
        "1053": "CarMax.com",
        "1057": "UsedCars.com",
        "1058": "the Dealership Site",
        "1059": "CarMax.com",
        "1060": "the Dealership Site",
        "1061": "DriveTime.com",
        "1063": "CARFAX.com",
        "1064": "CarZing.com",
        "1065": "the Dealership Site",
      },
      destUrl: ""
    };
  },
  mounted() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    let urlParams = new URLSearchParams(window.location.search);
    this.destUrl = urlParams.get("d");

    if (this.destUrl === null) {
      window.location.href = "https://www.carscience.com";
    } else {
      if (["1058", "1060", "1065"].includes(this.advertiserAccountId)) {
        this.advertiserName =
          urlParams.get("dlrn") != null
            ? urlParams.get("dlrn")
            : this.advertiserNameMap[this.advertiserAccountId];
      } else {
        this.advertiserName =
          this.advertiserAccountId in this.advertiserNameMap
            ? this.advertiserNameMap[this.advertiserAccountId]
            : "";
      }
      this.advertiserLogo =
        "https://landing.carscience.com/assets/images/partner_logos/" +
        this.advertiserAccountId +
        ".png";

      setTimeout(() => {
        sessionStorage.setItem("vehicle-out-redirected", "1");
        window.location.href = this.destUrl;
      }, 2500);

      const referrerUrl = document.referrer;
      if (referrerUrl.length > 0) {
        if (sessionStorage.getItem("vehicle-out-redirected") > 0) {
          sessionStorage.removeItem("vehicle-out-redirected");
          window.location.href = referrerUrl;
        }
        window.addEventListener("pageshow", () => {
          if (sessionStorage.getItem("vehicle-out-redirected") > 0) {
            sessionStorage.removeItem("vehicle-out-redirected");
            window.location.href = referrerUrl;
          }
        });
        window.addEventListener("focus", () => {
          if (sessionStorage.getItem("vehicle-out-redirected") > 0) {
            sessionStorage.removeItem("vehicle-out-redirected");
            window.location.href = referrerUrl;
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.out {
  .container {
    border-radius: 12px;
    padding: 24px;
    background: #f9f9f9;
    color: #000;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.15), 0 3px 4px rgba(0, 0, 0, 0.1),
      0 3px 3px -2px rgba(0, 0, 0, 0.08);
    text-align: center;
    max-width: 500px;
    margin: 0 24px;
  }
  /* HTML: <div class="loader"></div> */
  .loader {
    width: 15px;
    aspect-ratio: 1;
    border-radius: 50%;
    animation: l5 1s infinite linear alternate;
    transform: scale(1.25);
  }
  @keyframes l5 {
    0% {
      box-shadow: 30px 0 #000, -30px 0 #0002;
      background: #444;
    }
    33% {
      box-shadow: 30px 0 #000, -30px 0 #0002;
      background: #4442;
    }
    66% {
      box-shadow: 30px 0 #0002, -30px 0 #000;
      background: #4442;
    }
    100% {
      box-shadow: 30px 0 #0002, -30px 0 #000;
      background: #444;
    }
  }
}

.--fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000000;
  min-height: 100dvh;
  min-height: -webkit-fill-available;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ececec;
}
</style>
